import { useAccounts } from "./useAccounts";
import { useMemo } from "react";
/**
 * Generic hook to get a cached, auto updating, deserialized form of any Solana account. Massively saves on RPC usage by using
 * the spl-utils accountFetchCache.
 *
 * @param key
 * @param parser
 * @param isStatic
 * @returns
 */
export function useAccount(key, parser, isStatic = false) {
    const args = useMemo(() => key ? [key] : undefined, [key?.toBase58()]);
    const ret = useAccounts(args, parser, isStatic);
    return {
        loading: ret.loading,
        account: ret.accounts?.[0]?.account,
        info: ret.accounts?.[0]?.info,
        status: ret.status
    };
}
//# sourceMappingURL=useAccount.js.map